(() => {
  const controllers = new WeakMap();

  const createController = (section) => {
    const modal = section.querySelector('[data-quiz-modal]');
    const dialog = modal?.querySelector('.collection-quiz__dialog');
    const form = modal?.querySelector('[data-quiz-form]');
    const steps = [...(modal?.querySelectorAll('[data-quiz-step]') || [])];
    const progress = modal?.querySelector('[data-quiz-progress]');
    const backButton = modal?.querySelector('[data-quiz-back]');
    const nextButton = modal?.querySelector('[data-quiz-next]');
    const results = modal?.querySelector('[data-quiz-results]');
    const resultCards = [...(modal?.querySelectorAll('[data-quiz-result]') || [])];
    const restartButton = modal?.querySelector('[data-quiz-restart]');

    if (!modal || !dialog || !form || !steps.length || !progress || !backButton || !nextButton || !results || !resultCards.length || !restartButton) {
      return null;
    }

    const availableOutcomes = resultCards.map((card) => card.dataset.quizResult);
    let currentStep = 0;
    let restoreFocusTo = null;

    const selectedAnswer = (index) => steps[index]?.querySelector('[data-quiz-answer]:checked');
    const updateStep = () => {
      steps.forEach((step, index) => {
        step.hidden = index !== currentStep;
      });
      results.hidden = true;
      form.hidden = false;
      progress.textContent = `Question ${currentStep + 1} of ${steps.length}`;
      backButton.hidden = currentStep === 0;
      nextButton.disabled = !selectedAnswer(currentStep);
      nextButton.textContent = currentStep === steps.length - 1 ? 'See my match' : 'Next';
    };
    const reset = () => {
      form.reset();
      currentStep = 0;
      resultCards.forEach((card) => {
        card.hidden = true;
      });
      updateStep();
    };
    const recommendation = () => {
      const scores = Object.fromEntries(availableOutcomes.map((outcome) => [outcome, 0]));
      const answers = steps.map((_, index) => selectedAnswer(index));

      answers.forEach((answer) => {
        if (answer && Object.prototype.hasOwnProperty.call(scores, answer.value)) {
          scores[answer.value] += Number(answer.dataset.weight || 0);
        }
      });

      const highestScore = Math.max(...Object.values(scores));
      const tiedOutcomes = availableOutcomes.filter((outcome) => scores[outcome] === highestScore);
      const primaryOutcome = answers[0]?.value;
      return tiedOutcomes.includes(primaryOutcome) ? primaryOutcome : tiedOutcomes[0];
    };
    const showResults = () => {
      const outcome = recommendation();
      form.hidden = true;
      results.hidden = false;
      resultCards.forEach((card) => {
        card.hidden = card.dataset.quizResult !== outcome;
      });
      results.querySelector('a, button')?.focus();
    };
    const open = (trigger) => {
      restoreFocusTo = trigger;
      reset();
      modal.hidden = false;
      document.body.classList.add('collection-quiz-open');
      dialog.focus();
    };
    const close = () => {
      modal.hidden = true;
      document.body.classList.remove('collection-quiz-open');
      restoreFocusTo?.focus();
    };
    const trapFocus = (event) => {
      if (event.key !== 'Tab' || modal.hidden) return;
      const focusable = [...dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])')].filter(
        (element) => !element.closest('[hidden]')
      );
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    modal.querySelectorAll('[data-quiz-close]').forEach((button) => button.addEventListener('click', close));
    form.addEventListener('submit', (event) => event.preventDefault());
    form.addEventListener('change', () => {
      nextButton.disabled = !selectedAnswer(currentStep);
    });
    backButton.addEventListener('click', () => {
      currentStep = Math.max(0, currentStep - 1);
      updateStep();
      (selectedAnswer(currentStep) || steps[currentStep].querySelector('[data-quiz-answer]'))?.focus();
    });
    nextButton.addEventListener('click', () => {
      if (!selectedAnswer(currentStep)) return;
      if (currentStep === steps.length - 1) {
        showResults();
        return;
      }
      currentStep += 1;
      updateStep();
      (selectedAnswer(currentStep) || steps[currentStep].querySelector('[data-quiz-answer]'))?.focus();
    });
    restartButton.addEventListener('click', () => {
      reset();
      steps[0].querySelector('[data-quiz-answer]')?.focus();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) close();
      trapFocus(event);
    });

    return { open };
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-quiz-open]');
    if (!trigger) return;
    const section = trigger.closest('.collection-template');
    if (!section || section.dataset.quizInlineInitialized === 'true') return;
    let controller = controllers.get(section);
    if (!controller) {
      controller = createController(section);
      if (controller) controllers.set(section, controller);
    }
    controller?.open(trigger);
  });

  const requestedUrl = new URL(window.location.href);
  if (requestedUrl.searchParams.get('quiz') === 'open') {
    const section = document.querySelector('.collection-template');
    const controller = section ? createController(section) : null;
    if (controller) {
      requestedUrl.searchParams.delete('quiz');
      window.history.replaceState({}, '', `${requestedUrl.pathname}${requestedUrl.search}${requestedUrl.hash}`);
      window.requestAnimationFrame(() => controller.open(document.body));
    }
  }
})();
